import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {introAction, optionAction, summaryAction, toggleAction} from "../../redux/store";
import {useNavigate, useParams} from "react-router-dom";
import callPeerRemoteModule from "../../../core/utils/callPeerRemoteModule";


const useMsgReceive = (initConnectMode) => {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const currentVehicle = useSelector(state => state.optionWindow.currentVehicle);
  const configId = useSelector(state => state.qrcode.configId);
  const preselectionDetailReady = useSelector(state => state.toggle.preselectionDetailReady);
  const connectMode = useSelector(state => state.theme.connectMode);
  const specialTypeColorList = useSelector(state => state.optionWindow.specialTypeColorList);
  const CONFIG_DATA = useSelector(state => state.optionWindow.CONFIG_DATA);

  const background = CONFIG_DATA?.BACKGROUND;



  useEffect(() => {
    if(initConnectMode === "mediaWall" || !initConnectMode) {
      return;
    }

    const receiveMsg = async (e) => {
      if (!e.data.progress) {
        if(e.data.msg === "result:screenshot" || e.data.msg === "result:screenShot"){
          const dataKeys = Object.keys(e.data.data);
          const rearrange = dataKeys.map(item => {
            return { "id": item, "img" : e.data.data[item]}
          });


          dispatch(summaryAction.setScreenShotCode(configId));
          dispatch(summaryAction.setScreenShotImage(rearrange));

        } else if(e.data.msg === "assetLoad:end" || e.data.msg === "end:loading") {
          window.postMessage({
            msg: "set:special:color",
            data: {specialTypeColorList : specialTypeColorList}
          }, "*");
          dispatch(introAction.setLoadingState("assetLoad:end"));

          if (initConnectMode === "web") {
            if(window){
              window.postMessage({ msg: "canCamera"});
            }
          } else if (initConnectMode === "remote") {
            const remoteModePeerConnected = await callPeerRemoteModule(initConnectMode);
            if(remoteModePeerConnected) {
              remoteModePeerConnected.conn.sendData("canCamera");
            }
          }
        } else if (e.data.msg === "end:change:part") {
          if (preselectionDetailReady && connectMode === "web") {
            dispatch(toggleAction.setPreselectionDetailReady(false));
            dispatch(optionAction.setOptions({selection: "isGnb", value: false}));
            navigate(`/${params.lang}/${params.id}/configurator/exterior`);
          }
        }
      }
    }

    window.addEventListener('message', receiveMsg);
    return () => {
      window.removeEventListener('message', receiveMsg);
    }
  }, [configId, background, currentVehicle, preselectionDetailReady]);



  return {}

}

export default useMsgReceive;
